// extracted by mini-css-extract-plugin
module.exports = {"empty_container":"Empty_empty_container__XBFaa"};